import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from "uuid";

import StoreInfo from './StoreInfo';
import ManagerInfo from './ManagerInfo';
import RegisterStore from './RegisterStore';

import { toggleSidebar } from '../../../store/actions/layout';
import { getPreDataService } from '../../../services/registerApi';
import { showErrorMessage } from '../../../services/httpService';
import { getCitiesPostService, getStatesPostService } from '../../../services/customerService';

const Store = () => {
   const dispatch = useDispatch();
   const { isSidebarOpened } = useSelector(state => state.layout);

   const [section, setSection] = useState(1);
   const [states, setStates] = useState([]);
   const [uploadedImage, setUploadedImage] = useState("");
   const [cities, setCities] = useState([]);
   const [postUnits, setPostUnits] = useState([]);
   const [postNodes, setPostNodes] = useState([]);
   const [requestTxt, setRequestTxt] = useState({ initial: "", isChanged: false });
   const [rules, setRules] = useState({ show: false, text: "" });
   const [data, setData] = useState({
      requestTypeId: "",
      fileId: uuidv4(),
      details: {
         storeName: "",
         storeNameEn: "",
         storeType: "",
         cooperationType: "",
         storePostalCode: '',
         storePhoneNumber: '',

         managerName: '',
         managerNationalId: '',
         managerNationalIdSerial: '',
         managerBirthDate: '',
         managerPhoneNumber: '',

         stateId: '',
         cityId: '',
         postUnitId: '',
         postNodeId: '',

         aboutStore: "",
         requestText: "",
         rules: false,
         fileList: [],
      }
   });

   useEffect(() => {
      window.scrollTo(0, 0);
      const getPreData = async () => {
         const res = await getPreDataService("requests");
         if (res.error) {
            return showErrorMessage(res);
         } else {
            const req = res.data.requestTypes.find(item => item.eTitle === "new store");
            let temp = req.fields[6].value;
            temp = temp.replaceAll("storeName", " .......... ");
            temp = temp.replaceAll("fullName", " .......... ");
            temp = temp.replaceAll("cooperationType", " .......... ");
            setData(prev => ({
               ...prev,
               requestTypeId: req.id,
               details: { ...prev.details, requestText: temp }
            }));
            setStates(res.data.states.states);
            setRequestTxt(prev => ({ ...prev, initial: req.fields[6].value }));
            setRules(prev => ({ ...prev, text: req.fields[7].value }));
         }
      };
      getPreData();
   }, []);

   const handelChangeBirthDate = (e) => {
      setData(prev => ({ ...prev, details: { ...prev.details, managerBirthDate: e.toString() } }));
   };
   const handelChange = async (e) => {
      const { name, value } = e.target;
      if (name === "requestText") {
         setRequestTxt(prev => ({ ...prev, isChanged: true }));
         setData(prev => ({ ...prev, details: { ...prev.details, [name]: [value] } }));
      }
      else if (!requestTxt.isChanged && (name === "storeName" || name === "managerName")) {
         let temp = requestTxt.initial;
         temp = temp.replaceAll("storeName", name === "storeName" ? value : data.details?.storeName ?? " .......... ");
         temp = temp.replaceAll("fullName", name === "managerName" ? value : data.details?.managerName ?? " .......... ");
         temp = temp.replaceAll("cooperationType", name === "cooperationType" ? value : data.details?.cooperationType ?? " .......... ");
         setData(prev => ({ ...prev, details: { ...prev.details, [name]: value, requestText: temp } }));
      }
      else {
         name === 'stateId' && handelChangeState(value);
         name === 'cityId' && handelChangeCity(value);
         setData(prev => ({ ...prev, details: { ...prev.details, [name]: value } }));
      }
   };
   const handelChangeState = async (stateId) => {
      const res = await getStatesPostService(stateId);
      if (res.error) {
         showErrorMessage(res);
      } else {
         setCities(res.data.cities);
         setPostUnits(res.data.postUnits);
      }
   };
   const handelChangeCity = async (cityId) => {
      const res = await getCitiesPostService(data.details.stateId, cityId);
      if (res.error) {
         showErrorMessage(res);
      } else {
         setPostNodes(res.data.postNodes);
      }
   };

   return (
      <main
         className="progress"
         onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
      >
         <h1 className="progress__title">ثبت فروشگاه</h1>
         <ul className="progresstabs">
            <li className="progresstab next">
               <img src="/img/shop-svgrepo-com.svg" className="progresstab-img" />
               <h2 className="progresstab-title">مشخصات فروشگاه</h2>
            </li>
            <li className={section > 1 ? "progresstab next" : "progresstab"}>
               <img src="/img/identification.png" className="progresstab-img" />
               <h2 className="progresstab-title">مشخصات مدیر</h2>
            </li>
            <li className={section > 2 ? "progresstab next" : "progresstab"}>
               <img src="/img/check1-svgrepo-com.png" className="progresstab-img" />
               <h2 className="progresstab-title">ثبت درخواست</h2>
            </li>
         </ul>
         <div className="progress__body">
            {section === 1 &&
               <StoreInfo
                  uploadedImage={uploadedImage}
                  setUploadedImage={setUploadedImage}
                  data={data}
                  setData={setData}
                  section={section}
                  states={states}
                  cities={cities}
                  postUnits={postUnits}
                  postNodes={postNodes}
                  handelChange={handelChange}
                  nextSection={() => setSection(prev => prev + 1)}
               />
            }
            {section === 2 &&
               <ManagerInfo
                  data={data}
                  section={section}
                  handelChange={handelChange}
                  handelChangeBirthDate={handelChangeBirthDate}
                  nextSection={() => setSection(prev => prev + 1)}
                  prevSection={() => setSection(prev => prev - 1)}
               />
            }
            {section === 3 &&
               <RegisterStore
                  data={data}
                  setData={setData}
                  section={section}
                  rules={rules}
                  setRules={setRules}
                  handelChange={handelChange}
                  prevSection={() => setSection(prev => prev - 1)}
               />
            }
         </div>
      </main>
   );
};

export default Store;